var map = {
	"./agoda.svg": 183,
	"./airbnb.svg": 813,
	"./aspects.svg": 742,
	"./bad-reviews.svg": 664,
	"./booking.svg": 596,
	"./categories.svg": 731,
	"./filters.svg": 968,
	"./intro.svg": 599,
	"./locations.svg": 905,
	"./new-reviews.svg": 583,
	"./open-reviews.svg": 303,
	"./positive-reviews.svg": 390,
	"./prices.svg": 245,
	"./regions.svg": 42,
	"./timeline.svg": 590,
	"./tripadvisor.svg": 118
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 669;